/**
 * Simple Test Page
 * Minimal page to test if routing works
 */

export function SimpleTest() {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#1a1a2e",
      color: "white",
      fontFamily: "system-ui, sans-serif"
    }}>
      <div style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "3rem", marginBottom: "1rem" }}>
          Simple Test Page Works
        </h1>
        <p style={{ fontSize: "1.25rem", color: "#888" }}>
          If you can see this, routing is working correctly.
        </p>
        <div style={{ marginTop: "2rem" }}>
          <a
            href="/test"
            style={{
              color: "#8b5cf6",
              textDecoration: "underline"
            }}
          >
            Go to Test Hub
          </a>
        </div>
      </div>
    </div>
  );
}

export default SimpleTest;
